<template>
  <div class="foodleap-new-topbar">
    <!-- TopNavBar -->
    <nav class="fl-nav top-0 left-0 w-full z-50 bg-primary-slate shadow-xl">
      <div class="max-w-screen-2xl mx-auto tw-flex justify-between items-center px-8 py-4">
        <div class="text-xl font-black tracking-tighter text-white fl-logo w-36 cursor-pointer" @click="$router.push('/')"><img src="/images/logos/foodleap.webp"></div>
        <div class="hidden md:tw-flex items-center space-x-8 tracking-tight font-medium">
          <span
            :class="['fl-nav-link cursor-pointer transition-colors', currentPage === 'ecosystem' ? 'active text-white border-b-2 border-primary-green pb-1' : 'text-white/60 hover:text-white']"
            @click="$router.push('/dashboards/home')">Ecosystem</span>
          <span
            :class="['fl-nav-link cursor-pointer transition-colors', currentPage === 'transitions' ? 'active text-white border-b-2 border-primary-green pb-1' : 'text-white/60 hover:text-white']"
            @click="$router.push('/transitions')">Transitions</span>
          <span
            :class="['fl-nav-link cursor-pointer transition-colors', currentPage === 'intelligence' ? 'active text-white border-b-2 border-primary-green pb-1' : 'text-white/60 hover:text-white']"
            @click="$router.push('/intelligence')">Intelligence</span>
          <span
            :class="['fl-nav-link cursor-pointer transition-colors', currentPage === 'facilities' ? 'active text-white border-b-2 border-primary-green pb-1' : 'text-white/60 hover:text-white']"
            @click="$router.push('/facilities')">Facilities</span>
          <span
            :class="['fl-nav-link cursor-pointer transition-colors', currentPage === 'about' ? 'active text-white border-b-2 border-primary-green pb-1' : 'text-white/60 hover:text-white']"
            @click="$router.push('/about')">About</span>
        </div>
        <div class="tw-flex items-center space-x-3">
          <!--          <button class="text-white/60 hover:text-white transition-all active:scale-95">
                      <Icon name="search"/>
                    </button>-->
          <button @click="openSigninModal"
                  class="fl-btn-upgrade border border-white/30 hover:border-white/60 text-white px-6 py-2 rounded-full font-bold transition-all transform active:scale-95">
            Login
          </button>
          <button @click="openSignupModal"
                  class="fl-btn-upgrade bg-primary-green hover:opacity-90 text-primary-slate px-6 py-2 rounded-full font-bold transition-all transform active:scale-95">
            Register
          </button>
          <button
            class="text-white/50 hover:text-white transition-colors active:scale-95 transform mt-1"
            title="Provide Feedback"
            @click="openFeedbackWindow()"
          >
            <Icon name="information-outline" fill="white"/>
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../../store/modules/ui.js'
  import MODAL_IDS from '../../constants/modal-ids.js'
  import { trackHeapEvent } from '../../util/analytics.js'
  import NavigationItem from '../Navigation/NavigationItem.vue'
  import Icon from '../Icon/Icon.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {},
    data () {
      return {}
    },
    methods: {
      openFeedbackWindow () {
        document.querySelector('.userback-button-e').click()
      },
      openSigninModal () {
        trackHeapEvent('staticHomePage.topBarLogin')

        this.$router.push('/login')
      },
      openSignupModal () {
        trackHeapEvent('staticHomePage.topBarRegister')

        if (this.$store.getters.hasAccessToEcosystemMemberPackages) {
          this.$store.commit(UI_MUTATION_TYPES.SHOW_MODAL, MODAL_IDS.PACKAGES_SIGN_UP)
        } else {
          this.$router.push('/register')
        }
      },
    },
    computed: {
      currentPage () {
        const path = this.$route.path
        if (path === '/intelligence') return 'intelligence'
        if (path === '/transitions') return 'transitions'
        if (path === '/deep-dive-report') return 'intelligence'
        if (path === '/innovation-radar-report') return 'intelligence'
        if (path === '/transition-pulse-report') return 'intelligence'
        if (path === '/facilities') return 'facilities'
        if (path === '/about') return 'about'
        if (path === '/open-innovation') return 'intelligence'
        if (path === '/advisory') return 'intelligence'
        return 'ecosystem'
      },
      leftLogoUrl () {
        return this.config.logo_url_light || this.config.logo_url
      },
      isFoodleap () {
        return this.$store.getters.isFoodleap
      },
      registerButtonStyle () {
        return {
          backgroundColor: '#21244A',
          color: 'white',
          fontFamily: '',
          fontWeight: '',
          height: 'auto',
          textTransform: 'capitalize',
        }
      },
      loginButtonStyle () {
        return {
          backgroundColor: 'white',
          fontFamily: '',
          fontWeight: '',
          color: '#21244A',
          height: 'auto',
          width: '90px',
          border: '2px solid white',
          borderRadius: '4px',
          textTransform: 'capitalize',

        }
      },
      config () {
        return this.$store.state.config
      },
    },
    mounted () {
    },
    beforeUnmount () {
    },
    mixins: [],
    components: {
      NavigationItem,
      Icon,
    },
  })
</script>

<style scoped lang="scss">
  @import "../../../scss/variables";

  .foodleap-new-topbar {
    font-family: 'Inter', sans-serif;
    background-color: #21244A;
    color: #21244A;

    // Brand color variables
    $ps: #21244A; // primary-slate
    //$pg: #C8F58D; // primary-green
    $pg: #5CCC61;
    $blg: #D9E2DA; // brand-light-grey
    $svg: #B5F167; // secondary-vibrant-green
    $sy: #FFC83D; // secondary-yellow
    $sr: #EF374E; // secondary-red
    $sb: #70C1FF; // secondary-blue

    // ── Brand color utilities ────────────────────────────────────────────────

    .bg-primary-slate {
      background-color: $ps;
    }

    .bg-primary-green {
      background-color: $pg;
    }

    .bg-brand-light-grey {
      background-color: $blg;
    }

    .bg-secondary-vibrant-green {
      background-color: $svg;
    }

    .bg-primary-slate\/10 {
      background-color: rgba(33, 36, 74, 0.1);
    }

    .bg-primary-slate\/20 {
      background-color: rgba(33, 36, 74, 0.2);
    }

    .bg-primary-slate\/95 {
      background-color: rgba(33, 36, 74, 0.95);
    }

    .bg-ps-95 {
      background-color: rgba(33, 36, 74, 0.95);
      backdrop-filter: blur(24px);
    }

    .bg-primary-green\/10 {
      background-color: rgba(92, 204, 97, 0.1);
    }

    .bg-brand-light-grey\/20 {
      background-color: rgba(217, 226, 218, 0.2);
    }

    .bg-brand-light-grey\/30 {
      background-color: rgba(217, 226, 218, 0.3);
    }

    .bg-brand-light-grey\/50 {
      background-color: rgba(217, 226, 218, 0.5);
    }

    .bg-secondary-vibrant-green\/10 {
      background-color: rgba(181, 241, 103, 0.1);
    }

    .bg-secondary-vibrant-green\/20 {
      background-color: rgba(181, 241, 103, 0.2);
    }

    .bg-secondary-blue\/10 {
      background-color: rgba(112, 193, 255, 0.1);
    }

    .bg-secondary-yellow\/10 {
      background-color: rgba(255, 200, 61, 0.1);
    }

    .text-primary-slate {
      color: $ps;
    }

    .text-primary-green {
      color: $pg;
    }

    .text-secondary-blue {
      color: $sb;
    }

    .text-secondary-yellow {
      color: $sy;
    }

    .text-secondary-vibrant-green {
      color: $svg;
    }

    .text-secondary-red {
      color: $sr;
    }

    .text-primary-slate\/20 {
      color: rgba(33, 36, 74, 0.2);
    }

    .text-primary-slate\/40 {
      color: rgba(33, 36, 74, 0.4);
    }

    .text-primary-slate\/60 {
      color: rgba(33, 36, 74, 0.6);
    }

    .text-primary-slate\/70 {
      color: rgba(33, 36, 74, 0.7);
    }

    .text-primary-slate\/80 {
      color: rgba(33, 36, 74, 0.8);
    }

    .border-primary-green {
      border-color: $pg;
    }

    .border-brand-light-grey {
      border-color: $blg;
    }

    .border-brand-light-grey\/50 {
      border-color: rgba(217, 226, 218, 0.5);
    }

    .border-primary-slate\/30 {
      border-color: rgba(33, 36, 74, 0.3);
    }

    .border-secondary-blue\/20 {
      border-color: rgba(112, 193, 255, 0.2);
    }

    .border-secondary-yellow\/20 {
      border-color: rgba(255, 200, 61, 0.2);
    }

    .shadow-primary-slate-5 {
      box-shadow: 0 25px 50px -12px rgba(33, 36, 74, 0.05);
    }

    .shadow-primary-slate-20 {
      box-shadow: 0 20px 25px -5px rgba(33, 36, 74, 0.2), 0 8px 10px -6px rgba(33, 36, 74, 0.15);
    }


    .hover\:bg-brand-light-grey:hover {
      background-color: $blg;
    }

    .hover\:bg-brand-light-grey-80:hover {
      background-color: rgba(217, 226, 218, 0.8);
    }

    .hover\:bg-brand-light-grey\/80:hover {
      background-color: rgba(217, 226, 218, 0.8);
    }

    .hover\:text-primary-green:hover {
      color: $pg;
    }

    .hover\:border-primary-slate:hover {
      border-color: $ps;
    }

    .hover\:border-secondary-blue:hover {
      border-color: $sb;
    }

    .hover\:border-secondary-yellow:hover {
      border-color: $sy;
    }

    .focus\:ring-primary-slate:focus {
      --tw-ring-color: rgba(33, 36, 74, 0.5);
    }
  }
</style>
